import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What industries use AutoCAD?",
    
    description:
      "AutoCAD is widely used in civil engineering, architecture, mechanical design, electrical drafting, interior design, product design, and construction planning. It is essential wherever technical drawings are required.",
  },
  {
    title: "What skills are needed for AutoCAD?",
    
    description:
      "AutoCAD learners need spatial understanding, attention to detail, measurement accuracy, drafting knowledge, and familiarity with engineering drawings. Basic computer skills also support faster learning",
  },
  {
    title: "How long does it take to learn AutoCAD?",
   
    description:
      "Most learners grasp the basics in 2–4 weeks. Becoming job-ready may take 2–3 months with consistent practice and completing real-world drafting projects.",
  },
  {
    title: "Is AutoCAD good for architects?",
  
    description:
      "Yes, AutoCAD is a preferred tool for architects to create floor plans, building layouts, construction details, and accurate technical drawings required for approvals and execution.",
  },
  {
    title: "What job roles can I get with AutoCAD skills?",

    description:
      "Roles include AutoCAD Draftsman, CAD Technician, Architectural Drafter, Mechanical Drafter, Civil Draftsman, Interior Designer, and CAD Engineer across engineering and design industries.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                <div className="category">{item.category}</div>

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
